var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightNav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91001 20.6695C8.72001 20.6695 8.53001 20.5995 8.38001 20.4495C8.09001 20.1595 8.09001 19.6795 8.38001 19.3895L14.9 12.8695C15.38 12.3895 15.38 11.6095 14.9 11.1295L8.38001 4.60953C8.09001 4.31953 8.09001 3.83953 8.38001 3.54953C8.67001 3.25953 9.15001 3.25953 9.44001 3.54953L15.96 10.0695C16.47 10.5795 16.76 11.2695 16.76 11.9995C16.76 12.7295 16.48 13.4195 15.96 13.9295L9.44001 20.4495C9.29001 20.5895 9.10001 20.6695 8.91001 20.6695Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightNav);
export default __webpack_public_path__ + "static/media/arrow-right-nav.50e9f6bc58361c4b542b78dc57e9f89c.svg";
export { ForwardRef as ReactComponent };